import { HardBlockReason, HardBlockReasonType, RadioButtonOption, ReorderOption, SiteCoreDictionary } from '../types';

const getHardBlockReasonLabel = (reason: HardBlockReason, dictionary: SiteCoreDictionary): string | undefined => {
    const key = `blockReason_${reason}`;
    return dictionary[key];
};

export const getReasonOptions = (reasons: HardBlockReason[], dictionary: SiteCoreDictionary): RadioButtonOption[] =>
    reasons
        .filter((reason) => typeof getHardBlockReasonLabel(reason, dictionary) !== 'undefined')
        .map((reason) => ({
            id: reason,
            value: reason,
            label: getHardBlockReasonLabel(reason, dictionary),
            ...{
                'data-track-id': 'select-hard-block-reason-option',
                'data-track-linkname': reason,
            },
        }));

export const isValidHardBlockReason = (value: string): value is HardBlockReasonType =>
    Object.values(HardBlockReason).includes(value as HardBlockReason);

export const toHardBlockReasonEnum = (reason: string): HardBlockReasonType | undefined => {
    if (!isValidHardBlockReason(reason)) {
        return undefined;
    }

    return HardBlockReason[reason];
};

export const getReorderOptions = (dictionary: SiteCoreDictionary): RadioButtonOption[] => {
    const { reorderOptionYes, reorderOptionNo } = dictionary;

    return [
        {
            id: 'reorderOptionYes',
            value: ReorderOption.YES,
            label: reorderOptionYes,
            ...{
                'data-track-id': 'select-reorder-card-option',
                'data-track-linkname': ReorderOption.YES,
            },
        },
        {
            id: 'reorderOptionNo',
            value: ReorderOption.NO,
            label: reorderOptionNo,
            ...{
                'data-track-id': 'select-reorder-card-option',
                'data-track-linkname': ReorderOption.NO,
            },
        },
    ];
};

export const reorderValueToBooleanValue = (option: string) => option === ReorderOption.YES;

export const booleanOrUndefinedValueToReorderValue = (
    booleanValue: boolean | undefined,
    reorderOptions: RadioButtonOption[],
): string | undefined => {
    if (typeof booleanValue === 'undefined') {
        return undefined;
    }

    const wantedReorderValue = booleanValue ? ReorderOption.YES : ReorderOption.NO;

    return reorderOptions.find(({ value }) => value === wantedReorderValue)?.value;
};
